<template>
  <div v-if="container !== null">
    <b-modal
      :id="container.container_number"
      centered
      class="container-tracking-modal"
      hide-footer
      :title="
        $t('invoices.tracking.modal.title', {
          containerNumber: container.container_number
        })
      "
    >
      <div
        class="container-tracking-modal__update-status tracking-dots"
        v-for="(event, i) in events"
        :key="i"
        :class="{
          disabled: event.time.precision === 'expected',
          completed: event.time.precision === 'actual',
          active: activeClass(event, i)
        }"
      >
        <div class="event-location">
          {{ event.location }}
        </div>
        <div class="event-time">
          {{ event.time.time | formatDate('MMM, DD, YYYY') }}
        </div>
        <div class="event-status">
          {{ event.status }}
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      events: this.container !== null ? JSON.parse(this.container.events) : ''
    }
  },
  props: ['container'],
  methods: {
    activeClass(event, i) {
      if (typeof this.events[i + 1] !== 'undefined') {
        return this.events[i + 1].time.precision !== event.time.precision
          ? 'active'
          : ''
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/variables';
.container-tracking-modal__update-status {
  border-left: 3px solid $dc-svg;
  padding-left: 19px;
  position: relative;
  padding-bottom: 20px;
  margin-left: 1rem;
  &:before {
    margin-left: -30px;
  }
  &:after {
    margin-left: -25px;
    top: 5px;
  }
  &.active,
  &.disabled {
    border-left-color: $gray-300;
  }
  &:last-child {
    border-left-color: transparent;
  }
  .event-status {
    font-size: 0.8rem;
    text-transform: uppercase;
    color: $gray-600;
  }
  .event-time {
    font-size: 0.8rem;
  }
}
</style>
